import CrudApi from './crud';

export const crud = new CrudApi('/schools/:schoolId/classes/:classId/teachers', { only: ['store', 'destroy'] });
